// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"k995C":[function(require,module,exports) {
require("b0ce86772ecf6aa").register(require("5036a6324fb196a4").getBundleURL('e7tih'), JSON.parse("[\"e7tih\",\"iframe.56cbd750.js\",\"hlZrD\",\"Illustrations.f2e77245.js\",\"4ZPQU\",\"Illustrations.332a8521.js\",\"dG88v\",\"Illustrations.27040a92.js\",\"iDHM9\",\"Illustrations.6a68c954.css\",\"7mYVJ\",\"Illustrations.54f56e16.js\",\"bg39s\",\"Illustrations.4b1d4649.js\",\"42UBj\",\"Illustrations.bb0579c1.js\",\"8EufP\",\"Illustrations.56a0883c.js\",\"goo1g\",\"Illustrations.701ab6c2.css\",\"8ys0Z\",\"Illustrations.3a1d91f4.js\",\"hm9na\",\"Illustrations.ba4b21bb.css\",\"4vzCn\",\"Illustrations.3b67bf9e.js\",\"2vT9b\",\"Illustrations.04404220.css\",\"iw52z\",\"Intro.2ab29d61.js\",\"bMTTv\",\"wallpaper_collaborative_S2_desktop.1ae295a9.webp\",\"4hMcY\",\"Intro.d3009e2b.css\",\"bYwMW\",\"Migrating.a01866bc.js\",\"5Ezvz\",\"Migrating.e1c31096.css\",\"gA0sJ\",\"Release Notes.208af2d7.js\",\"4baLk\",\"Release Notes.2012730c.css\",\"dzAbz\",\"Style Macro.bb27393c.js\",\"3iCeS\",\"Style Macro.6794a897.css\",\"7Vowk\",\"Workflow Icons.1117bc6b.js\",\"61w15\",\"Workflow Icons.db9a7ffb.css\",\"8YPdm\",\"Accordion.stories.d2fbad7c.js\",\"fnSTa\",\"Accordion.stories.a8461c2e.css\",\"bFzeI\",\"ActionButton.stories.f0b1a11f.js\",\"5dyP0\",\"ActionButton.stories.0ac1359f.css\",\"4JCBi\",\"ActionMenu.stories.10b1f0ba.js\",\"4ljCu\",\"ActionMenu.stories.1184fe0c.css\",\"9tjEJ\",\"AlertDialog.stories.551330fb.js\",\"7Y4ap\",\"AlertDialog.stories.732d625d.css\",\"40tx1\",\"Avatar.stories.4913e5d9.js\",\"fNgMa\",\"Avatar.stories.ec607ea5.css\",\"f7hbz\",\"AvatarGroup.stories.4e8de14b.js\",\"ea6Sg\",\"AvatarGroup.stories.dbefced8.css\",\"4hMyY\",\"Badge.stories.8d36f69e.js\",\"gZlRQ\",\"Badge.stories.cdb2aaec.css\",\"5D23N\",\"Breadcrumbs.stories.7efaa305.js\",\"joLkH\",\"Breadcrumbs.stories.d355d3d7.css\",\"8wkL2\",\"Button.stories.997d55c7.js\",\"fwyxL\",\"Button.stories.206dd514.css\",\"DAX64\",\"ButtonGroup.stories.207d3553.js\",\"fPXdT\",\"ButtonGroup.stories.ce820ee7.css\",\"gp6W7\",\"Card.stories.8e505ca3.js\",\"gKbGV\",\"preview.fa2965aa.png\",\"8tqd5\",\"placeholder.f0db36ef.png\",\"glKNp\",\"Card.stories.e962652d.css\",\"4hLRd\",\"CardView.stories.76a3197f.js\",\"a0PYm\",\"CardView.stories.49cf31d3.css\",\"duGtz\",\"Checkbox.stories.ab20b0ff.js\",\"1war7\",\"Checkbox.stories.7860b4b3.css\",\"dEZgy\",\"CheckboxGroup.stories.e3f6af8a.js\",\"nABiU\",\"CheckboxGroup.stories.bf3f5721.css\",\"dvqbE\",\"ColorArea.stories.08db6be9.js\",\"53R3W\",\"ColorArea.stories.4178d41d.css\",\"lQqQL\",\"ColorField.stories.29e39d1b.js\",\"lEShE\",\"ColorField.stories.cf7f51c9.css\",\"7fXIA\",\"ColorSlider.stories.9081b946.js\",\"9POaP\",\"ColorSlider.stories.aaac23b4.css\",\"jtKCc\",\"ColorSwatch.stories.a4dfa4ec.js\",\"hLTtc\",\"ColorSwatch.stories.d18e06de.css\",\"cvMDO\",\"ColorSwatchPicker.stories.0c5710cb.js\",\"4B5cJ\",\"ColorSwatchPicker.stories.52bbda40.css\",\"5IauK\",\"ColorWheel.stories.7b79b312.js\",\"9znwZ\",\"ColorWheel.stories.7afcc53f.css\",\"iwZpX\",\"ComboBox.stories.51b8e60b.js\",\"kfwMw\",\"ComboBox.stories.9b6c3deb.css\",\"ffKDy\",\"ContextualHelp.stories.bb5ca3b6.js\",\"Meugt\",\"ContextualHelp.stories.3c599c0c.css\",\"5ThXV\",\"Dialog.stories.604b486b.js\",\"dVqYI\",\"Dialog.stories.631172b1.css\",\"jVd4U\",\"Disclosure.stories.215d7e6f.js\",\"eJFAK\",\"Disclosure.stories.c9745526.css\",\"juMWK\",\"Divider.stories.ea94a9f2.js\",\"iQuP8\",\"Divider.stories.27071a6f.css\",\"71zFu\",\"DropZone.stories.bdec2720.js\",\"q10SR\",\"DropZone.stories.dfbfd341.css\",\"hC7wN\",\"Form.stories.e9c96891.js\",\"gT5lr\",\"Form.stories.45d2c39b.css\",\"lDzQY\",\"Icon.stories.2ffd65d6.js\",\"gkPBF\",\"Icon.stories.5222e0f9.css\",\"4W3QW\",\"IllustratedMessage.stories.660003cd.js\",\"57Jji\",\"IllustratedMessage.stories.4279bb7a.css\",\"5SoYM\",\"InlineAlert.stories.e75b953d.js\",\"upnlX\",\"InlineAlert.stories.f3f8a7d6.css\",\"4mRoY\",\"Link.stories.3369ce82.js\",\"1ENKN\",\"Link.stories.e8dcc771.css\",\"1viCb\",\"LinkButton.stories.cb890053.js\",\"65fY3\",\"LinkButton.stories.1bac6d0b.css\",\"7h3LC\",\"Menu.stories.a4bd1ea3.js\",\"lzYNz\",\"normal.ded32008.png\",\"5xrcs\",\"multiply.9c18c7f4.png\",\"hqGpi\",\"screen.88c89678.png\",\"cfr4s\",\"Menu.stories.eaa16278.css\",\"bASEH\",\"Meter.stories.7715d6e1.js\",\"l1149\",\"Meter.stories.087b60aa.css\",\"3iWXi\",\"NumberField.stories.7d5adf66.js\",\"90j9Q\",\"NumberField.stories.b26f9ac2.css\",\"gZaQo\",\"Picker.stories.5e653b6b.js\",\"bb8d0\",\"Picker.stories.6b3b4113.css\",\"fMofD\",\"ProgressBar.stories.303b0bb0.js\",\"kubCY\",\"ProgressBar.stories.44a9263c.css\",\"iHrVO\",\"ProgressCircle.stories.7d70ca2f.js\",\"gy6l7\",\"ProgressCircle.stories.0508fffd.css\",\"faIvL\",\"RadioGroup.stories.a5804efb.js\",\"hmn50\",\"RadioGroup.stories.66972d08.css\",\"2LTpK\",\"RangeSlider.stories.486c5c91.js\",\"1ke6Y\",\"RangeSlider.stories.151b189f.css\",\"jDnrD\",\"SearchField.stories.a5b1ddfc.js\",\"bUrns\",\"SearchField.stories.98c34779.css\",\"ciY9L\",\"SegmentedControl.stories.6d849a68.js\",\"03sVg\",\"SegmentedControl.stories.065994f9.css\",\"duq8F\",\"Slider.stories.f36f9a48.js\",\"dZXyi\",\"Slider.stories.67a64d48.css\",\"2d6fU\",\"StatusLight.stories.c4cb16db.js\",\"elgda\",\"StatusLight.stories.5e6ab402.css\",\"7B8jj\",\"StyleMacro.stories.4f42ecac.js\",\"9SxHz\",\"StyleMacro.stories.80913f2c.css\",\"h3AUQ\",\"Switch.stories.191b1872.js\",\"572h6\",\"Switch.stories.f4f60657.css\",\"dlUsV\",\"TableView.stories.abba2332.js\",\"2ZJeL\",\"TableView.stories.00d494ac.css\",\"dUfTm\",\"Tabs.stories.227c5246.js\",\"ijRVD\",\"Tabs.stories.af23c340.css\",\"lYf5C\",\"TagGroup.stories.d1d7967e.js\",\"6sPF2\",\"TagGroup.stories.111a8908.css\",\"lUtos\",\"TextField.stories.62d5e69c.js\",\"4FwWl\",\"TextField.stories.201cd22d.css\",\"3pi8O\",\"ToggleButton.stories.5fce5c3b.js\",\"8ZTPq\",\"ToggleButton.stories.2c243dd3.css\",\"drJjK\",\"Tooltip.stories.86dfe0ec.js\",\"cZcod\",\"Tooltip.stories.436f3847.css\",\"6tlmd\",\"entry-preview.bc8d0520.js\",\"6hMZn\",\"entry-preview-docs.ea56dca7.js\",\"3PWBA\",\"entry-preview-docs.f3821449.js\",\"hNAok\",\"preview.bbe55cfb.js\",\"2XSxl\",\"preview.158babbd.js\",\"5XbQT\",\"react.84561488.js\",\"6PccT\",\"preview.44a40046.js\",\"fDj9j\",\"Color-6VNJS4EI.d46df97b.js\",\"4ImWz\",\"syntaxhighlighter-B5GMVT5T.8094853a.js\",\"3MhUf\",\"formatter-SWP5E3XI.e447da64.js\",\"4imh6\",\"WithTooltip-V3YHNWJZ.0bf9def8.js\",\"8LGI0\",\"preview.8da18e37.js\",\"1zxno\",\"preview.4315b93a.js\",\"aSaTs\",\"preview.8f9927ee.js\",\"bpVLM\",\"preview.2d4720f8.js\",\"cGZA6\",\"preview.d240604b.js\",\"bDQot\",\"preview.6133502a.js\",\"hk7WM\",\"preview.23a964d7.js\",\"iJ3VL\",\"axe.17fd487b.js\",\"l2bpF\",\"preview.fdf0a989.js\",\"4NoM6\",\"logo.5ec3ca99.svg\",\"cXi3I\",\"logo-dark.bdeff35f.svg\",\"2Lxm0\",\"preview.aaacb7e7.css\"]"));

},{"b0ce86772ecf6aa":"kK08P","5036a6324fb196a4":"kMf2L"}],"kK08P":[function(require,module,exports) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"kMf2L":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return '/';
}
function getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}]},["k995C"], null, "parcelRequire94c2")

//# sourceMappingURL=iframe.runtime.b5dc1695.js.map
